import { render, staticRenderFns } from "./HotWords.vue?vue&type=template&id=991da862&scoped=true"
import script from "./HotWords.vue?vue&type=script&lang=js"
export * from "./HotWords.vue?vue&type=script&lang=js"
import style0 from "./HotWords.vue?vue&type=style&index=0&id=991da862&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991da862",
  null
  
)

export default component.exports